'use client';

import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/panda/css';
import { AdSlotClient } from '@repo/programmatic-ads/components/ad-slot-client';
import { MapSidebarAdCta } from './map-sidebar-ad-cta';
const mapSidebarAdSlotStyles = css({
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  width: 'full',
  hideBelow: 'md',
  backgroundColor: '[rgba(255,255,255,0.025)]',
  '@media (max-height: 719px)': {
    display: 'none'
  },
  _before: {
    content: '"Ad"',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    height: '[250px]',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'whiteAlpha.40',
    fontSize: 'sm',
    pointerEvents: 'none'
  },
  '& #map-sidebar-ad': {
    position: 'relative',
    width: 'full',
    minHeight: '[250px]',
    maxWidth: '[336px]',
    // Aditude renders a 26px "report ad" control above the creative.
    maxHeight: '[calc(280px + 26px)]',
    marginInline: 'auto',
    overflow: 'hidden'
  }
});
export function MapSidebarAdSlot(t0) {
  const $ = _c(5);
  const {
    titleSlug
  } = t0;
  let t1;
  if ($[0] !== titleSlug) {
    t1 = {
      pageTargeting: {
        wemod_title: titleSlug
      }
    };
    $[0] = titleSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MapSidebarAdCta />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <AdSlotClient provider="aditude-maps-wand" slotId="pb-slot-left-web-1" divId="map-sidebar-ad" analyticsLocation="wand.com_map_page_sidebar" className={mapSidebarAdSlotStyles} metadata={t1} analyticsParams={null} forceShowAd={false}>{t2}</AdSlotClient>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}